const styles = {
  button: {
    height: 40,
    width: { xs: '100%', md: 'auto' },
    // '&.MuiButton-special': {
    //   color: (theme) => `${theme.palette.common.black}!important`,
    //   backgroundColor: (theme) => `${theme.palette.primary.light}!important`,
    //   border: '1px solid',
    //   borderColor: (theme) => `${theme.palette.third.light}!important`,
    //   '&.MuiButton-special:hover': {
    //     backgroundColor: (theme) => `${theme.palette.primary.contrastText}!important`,
    //   },
    //   '&.selected': {
    //     border: '1px solid',
    //     borderColor: (theme) => `${theme.palette.third.light}!important`,
    //   },
    // },
  },
}

export default styles
